/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} modalystPodEditorItemAddedToProductParams
* @property {string} buttonName - back/next/review/mockup/..
* @property {string} errorDescription - Error description
* @property {GUID} impressionId - Guid that will help connect between this event and other in the design flow
* @property {boolean} isSuccess - Is success upload
* @property {string} itemDetails - Image url/added text
* @property {string} itemLocation - front/back
* @property {string} itemType - image/text
* @property {string} modalystProductId - Modalyst_product_id - if the editor is opened in wix so the NULL
* @property {string} origin - Add panel/copy paste. how and from where the feature was added to the product
* @property {string} pageName - in what page the editor is shown
* @property {GUID} productId - Wix product id - Null if the editor is shown out of Wix
* @property {string} productName - product name
* @property {string} retailerProductId - retailer_product_id - if the editor is opened in wix so the NULL
* @property {string} supplierProductId - Supplier product id. If in Wix then Null
**/
/**
 * Name: Modalyst POD Editor - Item Added to Product. Evid: 45.
 * Event description: when user add design to the product in the editor.

 * buttonName - Type: string. Desc: back/next/review/mockup/..
 *
 * errorDescription - Type: string. Desc: Error description
 *
 * impressionId - Type: guid. Desc: Guid that will help connect between this event and other in the design flow
 *
 * isSuccess - Type: bool. Desc: Is success upload
 *
 * itemDetails - Type: string. Desc: Image url/added text
 *
 * itemLocation - Type: string. Desc: front/back
 *
 * itemType - Type: string. Desc: image/text
 *
 * modalystProductId - Type: string. Desc: Modalyst_product_id - if the editor is opened in wix so the NULL
 *
 * origin - Type: string. Desc: Add panel/copy paste. how and from where the feature was added to the product
 *
 * pageName - Type: string. Desc: in what page the editor is shown
 *
 * productId - Type: guid. Desc: Wix product id - Null if the editor is shown out of Wix
 *
 * productName - Type: string. Desc: product name
 *
 * retailerProductId - Type: string. Desc: retailer_product_id - if the editor is opened in wix so the NULL
 *
 * supplierProductId - Type: string. Desc: Supplier product id. If in Wix then Null
 * @param {modalystPodEditorItemAddedToProductParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var modalystPodEditorItemAddedToProduct = function (params) {
    return { evid: 45, src: 145, endpoint: 'print-on-demand', params: params };
};
/**
* @typedef {Object} modalystPodEditorCloseEditorClickedParams
* @property {GUID} impressionId - Guid that will help connect between this event and other in the design flow
* @property {string} modalystProductId - Modalyst_product_id - if the editor is opened in wix so the NULL
* @property {string} origin - close / finish design
* @property {GUID} productId - Wix product id - Null if the editor is shown out of Wix
* @property {string} productName - product name
* @property {string} retailerProductId - retailer_product_id - if the editor is opened in wix so the NULL
* @property {string} supplierProductId - Supplier product id. If in Wix then Null
**/
/**
 * Name: Modalyst POD Editor -Close Editor Clicked. Evid: 47.
 * Event description: when user delete design to the product in the editor.

 * impressionId - Type: guid. Desc: Guid that will help connect between this event and other in the design flow
 *
 * modalystProductId - Type: string. Desc: Modalyst_product_id - if the editor is opened in wix so the NULL
 *
 * origin - Type: string. Desc: close / finish design
 *
 * productId - Type: guid. Desc: Wix product id - Null if the editor is shown out of Wix
 *
 * productName - Type: string. Desc: product name
 *
 * retailerProductId - Type: string. Desc: retailer_product_id - if the editor is opened in wix so the NULL
 *
 * supplierProductId - Type: string. Desc: Supplier product id. If in Wix then Null
 * @param {modalystPodEditorCloseEditorClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var modalystPodEditorCloseEditorClicked = function (params) {
    return { evid: 47, src: 145, endpoint: 'print-on-demand', params: params };
};
/**
* @typedef {Object} modalystPodEditorEditorLoadedParams
* @property {GUID} impressionId - Guid that will help connect between this event and other in the design flow
* @property {string} modalystProductId - Modalyst_product_id - if the editor is opened in wix so the NULL
* @property {string} origin - marketplace, drafts, import list, sync list, and eventually Wix Admin
* @property {string} pageName - in what page the editor is shown
* @property {GUID} productId - Wix product id - Null if the editor is shown out of Wix
* @property {string} productName - product name
* @property {string} retailerProductId - retailer_product_id - if the editor is opened in wix so the NULL
* @property {string} supplierProductId - Supplier product id. If in Wix then Null
**/
/**
 * Name: Modalyst POD Editor - Editor loaded. Evid: 43.
 * Event description: fired when Modalyst POD editor is loaded.

 * impressionId - Type: guid. Desc: Guid that will help connect between this event and other in the design flow
 *
 * modalystProductId - Type: string. Desc: Modalyst_product_id - if the editor is opened in wix so the NULL
 *
 * origin - Type: string. Desc: marketplace, drafts, import list, sync list, and eventually Wix Admin
 *
 * pageName - Type: string. Desc: in what page the editor is shown
 *
 * productId - Type: guid. Desc: Wix product id - Null if the editor is shown out of Wix
 *
 * productName - Type: string. Desc: product name
 *
 * retailerProductId - Type: string. Desc: retailer_product_id - if the editor is opened in wix so the NULL
 *
 * supplierProductId - Type: string. Desc: Supplier product id. If in Wix then Null
 * @param {modalystPodEditorEditorLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var modalystPodEditorEditorLoaded = function (params) {
    return { evid: 43, src: 145, endpoint: 'print-on-demand', params: params };
};
/**
* @typedef {Object} modalystPodEditorNavigationButtonClickedParams
* @property {string} buttonName - back/next/review/mockup/..
* @property {GUID} impressionId - Guid that will help connect between this event and other in the design flow
* @property {string} modalystProductId - Modalyst_product_id - if the editor is opened in wix so the NULL
* @property {string} pageName - in what page the editor is shown
* @property {GUID} productId - Wix product id - Null if the editor is shown out of Wix
* @property {string} productName - product name
* @property {string} retailerProductId - retailer_product_id - if the editor is opened in wix so the NULL
* @property {string} supplierProductId - Supplier product id. If in Wix then Null
**/
/**
 * Name: Modalyst POD Editor - Navigation button clicked. Evid: 44.
 * Event description: when user clicks a CTA to navigate in the editor.

 * buttonName - Type: string. Desc: back/next/review/mockup/..
 *
 * impressionId - Type: guid. Desc: Guid that will help connect between this event and other in the design flow
 *
 * modalystProductId - Type: string. Desc: Modalyst_product_id - if the editor is opened in wix so the NULL
 *
 * pageName - Type: string. Desc: in what page the editor is shown
 *
 * productId - Type: guid. Desc: Wix product id - Null if the editor is shown out of Wix
 *
 * productName - Type: string. Desc: product name
 *
 * retailerProductId - Type: string. Desc: retailer_product_id - if the editor is opened in wix so the NULL
 *
 * supplierProductId - Type: string. Desc: Supplier product id. If in Wix then Null
 * @param {modalystPodEditorNavigationButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var modalystPodEditorNavigationButtonClicked = function (params) {
    return { evid: 44, src: 145, endpoint: 'print-on-demand', params: params };
};
/**
* @typedef {Object} modalystPodEditorItemDeletedFromProductParams
* @property {string} buttonName - back/next/review/mockup/..
* @property {string} errorDescription - Error description
* @property {GUID} impressionId - Guid that will help connect between this event and other in the design flow
* @property {boolean} isSuccess - Is success upload
* @property {string} itemDetails - Image url/added text
* @property {string} itemLocation - front/back
* @property {string} itemType - image/text
* @property {string} modalystProductId - Modalyst_product_id - if the editor is opened in wix so the NULL
* @property {string} origin - Add panel/copy paste. how and from where the feature was added to the product
* @property {string} pageName - in what page the editor is shown
* @property {GUID} productId - Wix product id - Null if the editor is shown out of Wix
* @property {string} productName - product name
* @property {string} retailerProductId - retailer_product_id - if the editor is opened in wix so the NULL
* @property {string} supplierProductId - Supplier product id. If in Wix then Null
**/
/**
 * Name: Modalyst POD Editor - Item Deleted from Product. Evid: 46.
 * Event description: when user delete design to the product in the editor.

 * buttonName - Type: string. Desc: back/next/review/mockup/..
 *
 * errorDescription - Type: string. Desc: Error description
 *
 * impressionId - Type: guid. Desc: Guid that will help connect between this event and other in the design flow
 *
 * isSuccess - Type: bool. Desc: Is success upload
 *
 * itemDetails - Type: string. Desc: Image url/added text
 *
 * itemLocation - Type: string. Desc: front/back
 *
 * itemType - Type: string. Desc: image/text
 *
 * modalystProductId - Type: string. Desc: Modalyst_product_id - if the editor is opened in wix so the NULL
 *
 * origin - Type: string. Desc: Add panel/copy paste. how and from where the feature was added to the product
 *
 * pageName - Type: string. Desc: in what page the editor is shown
 *
 * productId - Type: guid. Desc: Wix product id - Null if the editor is shown out of Wix
 *
 * productName - Type: string. Desc: product name
 *
 * retailerProductId - Type: string. Desc: retailer_product_id - if the editor is opened in wix so the NULL
 *
 * supplierProductId - Type: string. Desc: Supplier product id. If in Wix then Null
 * @param {modalystPodEditorItemDeletedFromProductParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var modalystPodEditorItemDeletedFromProduct = function (params) {
    return { evid: 46, src: 145, endpoint: 'print-on-demand', params: params };
};
/**
* @typedef {Object} modalystPodEditorSaveDesignClickedParams
* @property {string} ctaName - What CTA was clicked by the user: saveDesign/ saveAsDraft/saveToImportList
* @property {GUID} impressionId - Guid that will help connect between this event and other in the design flow
* @property {string} modalystProductId - Modalyst_product_id - if the editor is opened in wix so the NULL
* @property {string} origin - Where the editor is shown: wixProductPage/wixProductlist/modalyst
* @property {GUID} productId - Wix product id - Null if the editor is shown out of Wix
* @property {string} retailerProductId - retailer_product_id - if the editor is opened in wix so the NULL
**/
/**
 * Name: Modalyst POD Editor - Save Design Clicked. Evid: 42.
 * Event description: When user save design in Modlayst POD editor.

 * ctaName - Type: string. Desc: What CTA was clicked by the user: saveDesign/ saveAsDraft/saveToImportList
 *
 * impressionId - Type: guid. Desc: Guid that will help connect between this event and other in the design flow
 *
 * modalystProductId - Type: string. Desc: Modalyst_product_id - if the editor is opened in wix so the NULL
 *
 * origin - Type: string. Desc: Where the editor is shown: wixProductPage/wixProductlist/modalyst
 *
 * productId - Type: guid. Desc: Wix product id - Null if the editor is shown out of Wix
 *
 * retailerProductId - Type: string. Desc: retailer_product_id - if the editor is opened in wix so the NULL
 * @param {modalystPodEditorSaveDesignClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var modalystPodEditorSaveDesignClicked = function (params) {
    return { evid: 42, src: 145, endpoint: 'print-on-demand', params: params };
};
//# sourceMappingURL=index.js.map